const SET_AI_TOKENS = "SET_AI_TOKENS";

export { SET_AI_TOKENS };
